import React from 'react';
import '../../styles/CookieBanner.css';
import Cookies from 'js-cookie';
import { doGetCall } from '../../config/rest';

class GlobalAlert extends React.Component{
    constructor(){
        super();
        this.state = {showGlobalAlert: true, globalAlertData: null, showCookie: true}
    }
    componentDidMount(){
        let today = new Date().format('ISO8601');
        doGetCall('/wp-json/global/v1/banner')
        .then(res => {this.setState({globalAlertData: res},() => {
            this.state.globalAlertData.global_alert_banner.forEach(gab => {
                if(gab.start_date_time && gab.end_date_time){
                    if(new Date(gab.end_date_time).format('ISO8601') > today && today > new Date(gab.start_date_time).format('ISO8601')){
                        this.setState({timedGlobalAlert: gab.content})
                    }
                }
                else{
                    this.setState({defaultGlobalAlert: gab.content})
                }
            })
            this.state.globalAlertData.cookiy_policy_banner.forEach(cpb => {
                if(cpb.start_date_time && cpb.end_date_time){
                    if(new Date(cpb.end_date_time).format('ISO8601') > today && today > new Date(cpb.start_date_time).format('ISO8601')){
                        this.setState({timedCookiePolicy: cpb.content})
                    }
                }
                else{
                    this.setState({defaultCookiePolicy: cpb.content})
                }
            })
        })})
    }
    closeGlobalAlertBanner = () => {
        Cookies.set('user-closed-the-alert', true, {domain: '.efficientlearning.com'});
        this.setState({
            showGlobalAlert: false
        })
    }
    closeCookieBanner = () => {
        Cookies.set('consentManagementComponentValue', 'close', {domain: '.efficientlearning.com'});
        this.setState({
            showCookie: false
        })
    }
    render(){
        return(
            <>
            {!Cookies.get('user-closed-the-alert', {domain: '.efficientlearning.com'}) &&
            (this.state.timedGlobalAlert || this.state.defaultGlobalAlert) &&
            <div className={`global-alert-banner ${!this.state.showGlobalAlert?"d-none":""}`}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-10">
                            {this.state.timedGlobalAlert?
                            <div className="global-banner-title"
                            dangerouslySetInnerHTML={{__html: this.state.timedGlobalAlert}}>
                            </div>:
                            <div className="global-banner-title"
                            dangerouslySetInnerHTML={{__html: this.state.defaultGlobalAlert}}>
                            </div>
                            }
                        </div>
                        <div className="col-2 d-flex justify-content-end">
                            <i className="fa fa-times-circle global-banner-cross-icon" aria-hidden="true"
                            onClick={()=>{this.closeGlobalAlertBanner()}}></i>
                        </div>
                    </div>
                </div>
            </div>}
            {!Cookies.get('consentManagementComponentValue', {domain: '.efficientlearning.com'}) &&
            (this.state.timedCookiePolicy || this.state.defaultCookiePolicy) &&
            <div className={`cookie-policy-banner ${!this.state.showCookie?"d-none":""}`}>
                <div className="container-fluid">
                    <div className="row d-flex align-items-center">
                        <div className="col-12 col-sm-8 col-lg-10">
                            {this.state.timedCookiePolicy?
                            <p className="cookie-banner-title"
                            dangerouslySetInnerHTML={{__html: this.state.timedCookiePolicy}}>
                            </p>:
                            <p className="cookie-banner-title"
                            dangerouslySetInnerHTML={{__html: this.state.defaultCookiePolicy}}>
                            </p>
                            }
                        </div>
                        <div className="col-12 col-sm-4 col-lg-2 policy-close-button-alignment">
                            <div className="policy-close-button" onClick={()=>{this.closeCookieBanner()}}>
                                <p className="policy-close-text">CLOSE</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
            </>
        )
    }
}
export default GlobalAlert